import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import.meta.client && gsap.registerPlugin(ScrollTrigger)

export default defineNuxtPlugin((nuxtApp) => {
	const metaStore = useMetaStore()
	const config = useRuntimeConfig()
	const { $bus } = nuxtApp

	nuxtApp.hook('page:start', () => {
		if (import.meta.client) {
			metaStore.pageLoading = true
			nuxtApp.$bus.$emit('page-start')
		}
	})

	nuxtApp.hook('page:finish', () => {
		metaStore.pageLoading = false

		if (import.meta.client && metaStore.firstLoad) {
			metaStore.firstLoad = false
		}

		nuxtApp.$bus.$emit('page-finish')
	})

	nuxtApp.hook('page:transition:finish', () => {
		if (import.meta.client && config.public.environment === 'development') {
			console.log('DefaultLayout: finished navigating - scrolltriggers alive: ', ScrollTrigger.getAll())
		}
	})
})